import * as S from './styles';
import { useGlobals } from '@/hooks';
import ButtonToTop from '../button-to-top/ButtonToTop';
import { getHorizontalScrollPosition } from '@/shared/buttonScrollPosition';

interface FloatButtonToTopProps {
  elementId: string;
  bottom?: number;
  onPress?: () => void;
  className?: string;
  enabledScroll?: boolean;
}

const FloatButtonToTop = ({ onPress, elementId, bottom, className, enabledScroll }: FloatButtonToTopProps) => {
  const { scrollDirection } = useGlobals();
  const positionFloatButton = getHorizontalScrollPosition(elementId);

  return (
    <S.FloatButton
      className={className}
      style={{ left: positionFloatButton }}
      $bottom={enabledScroll ? (scrollDirection !== 'down' ? undefined : 10) : (bottom ?? 10)}
    >
      <ButtonToTop onPress={onPress} />
    </S.FloatButton>
  );
};

export default FloatButtonToTop;
